import React, { useState, useEffect } from "react";
import { Box, Button, Grid, InputAdornment, Pagination, Popover, TextField, Tooltip, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import SentimentNeutralOutlinedIcon from "@mui/icons-material/SentimentNeutralOutlined";
import SentimentSatisfiedOutlinedIcon from "@mui/icons-material/SentimentSatisfiedOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import CommonMoreActionOptionModal, { ViewTranscriptModal } from "./CommonMoreActionOptionModal";
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CommonToast from "../../../../Common_Components/CommonToast";
import { DownloadCSVFileForAgent, DownloadCSVFileForContact, GetDetailContactAgentbyIdForCallingAgent, GetDetailVoiceAgentbyIdForCallingAgent } from "../../../../../contexts/WorkspaceUtils";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CircularLoader from "../../Track_Website/CircularLoader";
import { saveAs } from 'file-saver';
import { Spinner } from "react-bootstrap";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const userOptions = [
  {
    label: "View transcript",
    icon: <ArticleOutlinedIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Edit")
  },
  {
    label: "Download recording",
    icon: <SaveAltOutlinedIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Delete")
  },
  {
    label: "View customer analysis",
    icon: <PersonSearchIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Delete")
  },
]

      const theme = createTheme({
          typography: {
            fontFamily: "Inter",
          },
          components: {
            MuiPagination: {
              styleOverrides: {
                root: {
                  "& .MuiPaginationItem-root": {
                    color: "#ffffff",
                    borderRadius: "20px",
                    "&:hover": {
                      backgroundColor: "rgba(179, 168, 183, 0.26)",
                    },
                    fontSize: "14px",
                  },
                  "& .MuiPaginationItem-page.Mui-selected": {
                    backgroundColor: "#CAC4D0",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#CAC4D0",
                    },
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    color: "#ffffff",
                  },
                  "& .MuiPaginationItem-previousNext": {
                    color: "#ffffff",
                    borderRadius: "20px",
                  },
                },
              },
            },
          },
        });


          const customTextFieldStylesForInvalid = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
        padding:"13px 10px"
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "rgba(255, 255, 255, 0.40)",
      },
    };
  };

const Details = ({ name, id, csvId ,setopenUserDetails, place}) => {
  const [showMoreOption, setShowMoreOption] = useState(null)
  const [moreActionOptionArray, setMoreActionOptionArray] = useState(null)
  const [userDetailsArray, setUserDetailsArray] = useState([])
  const [openToast, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeUserObject, setActiveUserObject] = useState(null);
  const [sentimentCounts, setSentimentCounts] = useState({
    positive: 0,
    neutral: 0,
    negative: 0
  });
  const [totalDuration, setTotalDuration] = useState(0);
  const [totalSession, setTotalSession] = useState(0);
  const [openDetailsModal, setOpenDetailsModal] = useState(false)
  const [title, setTitle] = useState("")
  const [expandedRows, setExpandedRows] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedOptionForCSVDownload, setSelectedOptionForCSVDownload] = useState("custom");
  const [selectedStartDateForCSVDownload, setSelectedStartDateForCSVDownload] = useState("");
  const [selectedEndDateForCSVDownload, setSelectedEndDateForCSVDownload] = useState("");
  const [DownloadCSVLoader, setDownloadCSVLoader] = useState(false);

  // const handleOptionSelectedForCSVDOwnload = (option) => {
  //   // console.log("today event happen", e.target.value)
  //   if(option == "today"){
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   const month = String(today.getMonth() + 1).padStart(2, '0');
  //   const day = String(today.getDate()).padStart(2, '0');
  //   const formattedDate = `${year}-${month}-${day}`;
    
  //   setSelectedStartDateForCSVDownload(formattedDate);
  //   setSelectedEndDateForCSVDownload(formattedDate);
  //   }
  //   setSelectedOptionForCSVDownload(option)
  // }

  const handleOptionSelectedForCSVDOwnload = (option) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const formattedToday = `${year}-${month}-${day}`;

  if (option === "today") {
    setSelectedStartDateForCSVDownload(formattedToday);
    setSelectedEndDateForCSVDownload(formattedToday);
  } 
  else if (option === "this_week") {
    // Calculate Monday of this week (from today backward)
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // How many days back to Monday
    
    const monday = new Date(today);
    monday.setDate(today.getDate() - diffToMonday);
    
    const mondayYear = monday.getFullYear();
    const mondayMonth = String(monday.getMonth() + 1).padStart(2, '0');
    const mondayDay = String(monday.getDate()).padStart(2, '0');
    const formattedMonday = `${mondayYear}-${mondayMonth}-${mondayDay}`;
    
    setSelectedStartDateForCSVDownload(formattedMonday);
    setSelectedEndDateForCSVDownload(formattedToday);
  }
  else if (option === "this_month") {
    // First day of current month
    const firstDayOfMonth = new Date(year, today.getMonth(), 1);
    const firstDayYear = firstDayOfMonth.getFullYear();
    const firstDayMonth = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0');
    const firstDayDay = String(firstDayOfMonth.getDate()).padStart(2, '0');
    const formattedFirstDay = `${firstDayYear}-${firstDayMonth}-${firstDayDay}`;
    
    setSelectedStartDateForCSVDownload(formattedFirstDay);
    setSelectedEndDateForCSVDownload(formattedToday);
  }

  setSelectedOptionForCSVDownload(option);
}


  const handleCloseForCloseModalDownload = () => {
    setAnchorEl(null);
  };

  const handleClickForOpenModalDownload = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const HandleViewTranscriptModalCloseClick = () => {
    setOpenDetailsModal(false);
    setActiveUserObject(null)
    setTitle("");
  }

  const toggleExpandedSummary = (row) => {
    setTitle("Summary")
    setActiveUserObject(row?.summary)
    setOpenDetailsModal(true)
  };

  const toggleExpanded = (row) => {
    setTitle("Custom analysis")
    setActiveUserObject(row?.custom_analysis)
    setOpenDetailsModal(true)
  };

  
  const getShortText = (text, maxChars = 80) => {
    const short = text?.slice(0, maxChars);
    return short + (text?.length > maxChars ? "..." : "");
  };

  useEffect(() => {
    setMoreActionOptionArray(userOptions)
  }, [])

  const handleToastClose = () => {
    setOpen(false);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
  
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are 0-indexed
    const year = date.getFullYear();
  
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
  
    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  }
  



    const GetUserCallDetail =async () => {
      setLoading(true)
      try{
        const res = await GetDetailContactAgentbyIdForCallingAgent(id, currentPage)
        const userdata = await res.json()
        // console.log("userData", userdata)
        if(userdata.status){
          setUserDetailsArray(userdata?.data?.data)
          // let positive = 0;
          // let neutral = 0;
          // let negative = 0;
          // let durationSum = 0;
          // userdata?.data?.data?.forEach(call => {
          //   // Count sentiments
          //   if (call.sentiment === 'Positive') positive++;
          //   else if (call.sentiment === 'Neutral') neutral++;
          //   else if (call.sentiment === 'Negative') negative++;
      
          //   // Sum durations
          //   durationSum += Number(call.duration) || 0; // in case duration is missing or null
          // });
          setTotalPages(userdata?.data?.pagination?.total_pages)
          // setSentimentCounts({ positive, neutral, negative });
          // setTotalDuration(durationSum);
          setSentimentCounts(prevCounts => ({...prevCounts, positive: userdata?.data?.metadata?.sentiments?.positive,  negative:  userdata?.data?.metadata?.sentiments?.negative,  neutral:  userdata?.data?.metadata?.sentiments?.neutral  }));
          // setSentimentCounts(prevCounts => ({...prevCounts, }));
          // setSentimentCounts(prevCounts => ({...prevCounts,}));
          setTotalDuration(((userdata?.data?.metadata?.total_duration)/60).toFixed(2));
          setTotalSession(userdata?.data?.metadata?.total_sessions)
        }else{
          setOpen(true);
          setContent(userdata?.message);
          setIconType('error');
        }
      }catch(error){
        console.log(error)
        setOpen(true);
        setContent(error?.message);
        setIconType('error');
      }finally{
        setLoading(false)
      }
    }


    const GetUserCallDetailforVoiceagant =async () => {
      setLoading(true)
      try{
        const res = await GetDetailVoiceAgentbyIdForCallingAgent(id, currentPage)
        const userdata = await res.json()
        if(userdata.status){
          setUserDetailsArray(userdata?.data?.data)
          // let positive = 0;
          // let neutral = 0;
          // let negative = 0;
          // let durationSum = 0;
          // userdata?.data?.data?.forEach(call => {
          //   // Count sentiments
          //   if (call.sentiment === 'Positive') positive++;
          //   else if (call.sentiment === 'Neutral') neutral++;
          //   else if (call.sentiment === 'Negative') negative++;
      
          //   // Sum durations
          //   durationSum += Number(call.duration) || 0; // in case duration is missing or null
          // });
          setTotalPages(Math.ceil(userdata?.data?.pagination?.total_pages))
          setSentimentCounts(prevCounts => ({...prevCounts, positive: userdata?.data?.metadata?.sentiments?.positive,  negative:  userdata?.data?.metadata?.sentiments?.negative,  neutral:  userdata?.data?.metadata?.sentiments?.neutral  }));
          setTotalDuration( ((userdata?.data?.metadata?.total_duration)/60).toFixed(2));
          setTotalSession(userdata?.data?.metadata?.total_sessions)
          // setSentimentCounts({ positive, neutral, negative });
          // setTotalDuration(durationSum);
        }else{
          setOpen(true);
          setContent(userdata?.message);
          setIconType('error');
        }
      }catch(error){
        console.log(error)
        setOpen(true);
        setContent(error?.message);
        setIconType('error');
      }finally{
        setLoading(false)
      }
    }

      useEffect(()=>{
        if(place === "voiceAgent"){
          GetUserCallDetailforVoiceagant()
        }else if(place === "contact"){
          GetUserCallDetail()
        }
      },[currentPage])

  useEffect(()=>{
    setUserDetailsArray()
  },[])

  const HandleActionMoreOptionClick = (event, row ) => {
    event.stopPropagation()
    setShowMoreOption(event.currentTarget)
    setActiveUserObject(row)
  }

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const downloadFile =async (obj) => {
  const downloadUrl = obj?.download_url
  const filename =  obj?.file_name

  try {
    // Fetch the file as a blob
    const response = await window.__originalFetch(downloadUrl);
    const blob = await response.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download failed:", error);
     setOpen(true)
     setContent(error?.message)
     setIconType("error")
  }finally{
    handleCloseForCloseModalDownload()
  }
  }

  const handleDownload = async () => {
    setDownloadCSVLoader(true)
  try{
    const req = await DownloadCSVFileForAgent(id, selectedStartDateForCSVDownload, selectedEndDateForCSVDownload)
    const res = await req.json()
    if(res.status){
    await downloadFile(res.data)
    setOpen(true)
    setContent(res?.message)
    setIconType("success")
    }else{
    setOpen(true)
    setContent(res?.message)
    setIconType("error")
    }
  }catch(error){
     console.error("Download failed:", error);
     setOpen(true)
     setContent(error?.message)
     setIconType("error")
  }
  setDownloadCSVLoader(false)
};

const handleDownloadForContact = async () => {
    setDownloadCSVLoader(true)
  try{
    const req = await DownloadCSVFileForContact(id, selectedStartDateForCSVDownload, selectedEndDateForCSVDownload)
    const res = await req.json()
    if(res.status){
      await downloadFile(res.data)
    setOpen(true)
    setContent(res?.message)
    setIconType("success")
    }else{
    setOpen(true)
    setContent(res?.message)
    setIconType("error")
    }
  }catch(error){
    console.error("Download failed:", error);
    setOpen(true)
    setContent(error?.message)
    setIconType("error")
  }
    setDownloadCSVLoader(false)
}


 
  const HandleDownloadCSVFile =async () => {
    if(place === "voiceAgent"){
     await  handleDownload()
    }else{
      await  handleDownloadForContact()
    }
  }


  const renderCalendra = () => {
    return (
      <>
      {
         ( selectedOptionForCSVDownload == "custom" || selectedOptionForCSVDownload == "today" || selectedOptionForCSVDownload == "this_week"  || selectedOptionForCSVDownload == "this_month" )?
           <Box> 
            <Box sx={{display:"flex", flexDirection:"row", columnGap:"20px", margin : "24px 0px"}}>
                              <TextField disabled={selectedOptionForCSVDownload !=="custom"}
                                type="date"
                                value={selectedStartDateForCSVDownload}
                                onChange={(e)=>setSelectedStartDateForCSVDownload(e.target.value)}
                                label="Start Date*"
                                variant="outlined"
                                sx={{
                                  ...customTextFieldStylesForInvalid(false),
                                  maxHeight: "48px",
                                  "& .MuiInputAdornment-root": {
                                    color: "rgba(255, 255, 255, 0.8)", // custom text color
                                    fontWeight: 500,
                                    fontSize: "16px",
                                  },
                                   "&:hover": {
                                    color: "rgba(255, 255, 255, 0.4)", // custom text color                                
                                  },
                                   "& .MuiOutlinedInput-root.Mui-disabled": {
                                    "& fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    }
                                  }
                                }}
                                 InputLabelProps={{
                                  shrink: true, // This will force the label to always appear above the input
                                }}
                                placeholder="Select start date"
                              />
                              {/* <FormHelperText
                                sx={{
                                  color:
                                    "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "16px",
                                  margin: "4px 0px 0px 16px",
                                  alignSelf: "start",
                                }}
                              >
                                {(amount === null  || amount < 10) && `$10 minimum`}
                              </FormHelperText> */}

                                <TextField disabled={selectedOptionForCSVDownload !=="custom"}
                                type="date"
                                value={selectedEndDateForCSVDownload}
                                onChange={(e)=>setSelectedEndDateForCSVDownload(e.target.value)}
                                label="End Date*"
                                variant="outlined"
                                sx={{
                                  ...customTextFieldStylesForInvalid(false),
                                  maxHeight: "48px",
                                  "& .MuiInputAdornment-root": {
                                    color: "rgba(255, 255, 255, 0.8)", // custom text color
                                    fontWeight: 500,
                                    fontSize: "16px",
                                  },
                                   "&:hover": {
                                    color: "rgba(255, 255, 255, 0.4)", // custom text color                             
                                  },
                                  "& .MuiOutlinedInput-root.Mui-disabled": {
                                    "& fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    }
                                  }
                                }}
                                 InputLabelProps={{
                                  shrink: true, // This will force the label to always appear above the input
                                }}
                                placeholder="Select end date"
                              />
                            </Box>
{/* 
              <Button disabled={DownloadCSVLoader}
                          onClick={HandleDownloadCSVFile}
                           sx={{
                             width: "100%",
                             height: "40px",
                             textTransform: "none",
                             fontFamily: "Inter",
                             fontSize: "16px",
                             fontWeight: 600,
                             textAlign: "center",
                             bgcolor: "rgba(246, 190, 107, 1)",
                             color: "rgba(23, 24, 44, 1)",
                             borderRadius: "8px",
                             "&:hover": {
                                   backgroundColor: "#ffd9aa", 
                             },
                           }}
                         >
                        {
                          DownloadCSVLoader ? <Spinner
                                  as="span"
                                  animation="border"
                                  size="md"
                                  role="status"
                                  aria-hidden="true"
                                /> : " Download data (.csv)"
                        } 
              </Button> */}
           </Box>
          : null
      }
           <Box sx={{display:"flex", flexDirection:"row", columnGap:"16px", justifyContent:"flex-end"}}>
              <Button
                           onClick={handleCloseForCloseModalDownload}
                           sx={{
                             width: "100%",
                             maxWidth:"63px",
                             height: "40px",
                             textTransform: "none",
                             fontFamily: "Inter",
                             fontSize: "16px",
                             fontWeight: 600,
                             textAlign: "center",
                             color: "#ffffff",
                             borderRadius: "8px",
                                "&:hover": {
                                  color:"rgba(255, 255, 255, 0.8)",
                                  backgroundColor:"transparent"
                                },
                           }}
                         > Cancel </Button>
            <Button disabled={DownloadCSVLoader}
                           onClick={HandleDownloadCSVFile}
                           sx={{
                             width: "100%",
                            maxWidth:"250px",
                             height: "40px",
                             textTransform: "none",
                             fontFamily: "Inter",
                             fontSize: "16px",
                             fontWeight: 600,
                             textAlign: "center",
                             bgcolor: "rgba(246, 190, 107, 1)",
                             color: "rgba(23, 24, 44, 1)",
                             borderRadius: "8px",
                             "&:hover": {
                                   backgroundColor: "#ffd9aa", 
                             },
                           }}
                         >
                           {
                          DownloadCSVLoader ? <Spinner
                                  as="span"
                                  animation="border"
                                  size="md"
                                  role="status"
                                  aria-hidden="true"
                                /> : " Download data (.csv)"
                        } 
            </Button>
            </Box>
    </>
    )
  } 


  return (
    <div>
      <Box
        sx={{
          fontFamily: "Inter",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "20px",
          color: "rgba(255, 255, 255, 0.90)",
          marginBottom: "40px",
          display: "flex",
          flexDirection: "row",
          columnGap: "22px",
        }}
      >
        <ArrowBackIcon onClick={() => { setopenUserDetails(false) }} sx={{cursor:"pointer"}}/>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
            color: "rgba(255, 255, 255, 0.90)",
          }}
        >
          {" "}
          {name ? name : ""}
        </Typography>
      </Box>
      {/* Dashboard content goes here */}
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={2.3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Total Sessions
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {totalSession}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <LocalPhoneIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={2.3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Total positive
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {sentimentCounts?.positive}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#0E2E1E",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <SentimentSatisfiedOutlinedIcon sx={{ color: "#23A565" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={2.3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Total negative
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                   {sentimentCounts?.negative}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#2E0E0F",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <SentimentDissatisfiedOutlinedIcon sx={{ color: "#DD2025" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={2.3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Total neutral
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                 {sentimentCounts?.neutral}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#312C1A",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <SentimentNeutralOutlinedIcon sx={{ color: "#EED680" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={2.3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Total duration (min)
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {totalDuration}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <TimerOutlinedIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{border:"", marginTop: "40px",}}>
        <Button
         onClick={handleClickForOpenModalDownload} 
        sx={{display:"flex", placeSelf:"flex-end", textTransform:"none", maxWidth:'210px', display:"flex", flexDirection:"row", columnGap:"10px", padding:"8px 12px", bgcolor:"#282D51", marginLeft:"20px", borderRadius:"8px"}}>
                    <SaveAltOutlinedIcon style={{ color: 'white' }} />
                    <Typography sx={{fontFamily:"Inter", fontSize:"14px", fontStyle:"normal", fontWeight:400, lineHeight:"19.6px", letterSpacing:"0.1px", color: 'white'}}>Download data (.csv)</Typography>
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#171A2D",
          marginTop: "20px",
          padding: "20px",
          maxHeight:"600px",
          overflowY:"auto",
          border:"1px solid rgba(255, 255, 255, 0.10)",
          borderRadius:"16px"
        }}
      >
        <Box>
          {
                loading ? 
                  <CircularLoader  msg={"Loading..."} /> 
              :
              <TableContainer>
              <Table
                sx={{
                  fontFamily: "Inter",
                  color: "#ffffff",
                  padding: "20px 20px",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                        align="left"
                        sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 12px 16px 4px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        minWidth:"124px"
                        }}
                         >
                        Customer name
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 20px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        minWidth:"92px",
                      }}
                    >
                      Call ID
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 20px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        // width:"111px",
                        minWidth:"148px"
                      }}
                    >
                      Type
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 20px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        // width:"120px",
                        minWidth:"120px"
                      }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 10px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth:"120px"
                          }}>
                      Call from/to
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 20px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        // width:"112px",
                        minWidth:"112px"
                      }}
                    >
                      Duration
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 0px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        // width:"84px",
                        minWidth:"84px"
                      }}
                    >
                      Sentiment
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "20px 24px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        minWidth:"140px"
                      }}
                    >
                      Summary
                    </TableCell>
                    {/* <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 6px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        minWidth:"140px"
                      }}
                    >
                      Custom analysis
                    </TableCell> */}
                    <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 10px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        minWidth:"80px"
                      }}
                    >
                      Actions
                    </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {userDetailsArray?.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                      align="left"
                      sx={{
                        fontFamily: "Inter",
                        color: "#ffffff",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "28px",
                        padding: "16px 20px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        minWidth: "124px",
                      }}
                    >
                      {row?.name}
                    </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth: "92px",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {row?.session_id
                              ? `${row.session_id.split("").slice(0, 20).join("")}...`
                              : ""}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 14px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth: "148px",
                        }}
                      >
                      <Tooltip
                                                  componentsProps={{
                                                    tooltip: {
                                                      sx: {
                                                          bgcolor: "#E6E0E9",
                                                          color: "#17182C",
                                                          fontFamily: "Inter",
                                                          fontSize: "12px",
                                                          fontWeight: 500,
                                                          // padding: "4px 8px 4px 8px",
                                                          borderRadius: "4px",
                                                          textAlign: "center",
                                                          },
                                                      },
                                                  }}
                                                  title={`${row?.direction}`}
                                                >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            columnGap: "10px",
                            width: "120px",
                            height: "36px",
                            backgroundColor: "#1F233E",
                            padding: "0px",
                            borderRadius: "8px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Box sx={{}}>
                            {row?.type === "web_call" ? (
                              <LanguageIcon
                                width="16px"
                                height="16px"
                                sx={{ color: "#CAC4D0" }}
                              />
                            ) : (
                              <LocalPhoneIcon
                                width="16px"
                                height="16px"
                                sx={{ color: "#CAC4D0" }}
                              />
                            )}
                          </Box>
                          <Box
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              fontSize: "14px",
                            }}
                          >
                            {row?.type}
                          </Box>
                        </Box></Tooltip>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth: "120px",
                        }}
                      >
                        {formatDateTime(row?.created_at)}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 10px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth: "120px",
                        }}
                      >
                       {/* {`From: ${row?.from_number} To: ${row?.to_number}`} */}
                       {row?.from_number || row?.to_number
                      ? `${row?.from_number ? `From: ${row.from_number}` : ''}${row?.to_number ? ` To: ${row.to_number}` : ''}`
                      : 'N/A'}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth: "auto",
                        }}
                      >
                        {/* {`${row?.duration/1000} seconds`} */}
                        {row?.duration ? `${(row.duration / 1000).toFixed(1)} seconds` : 'N/A'}

                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          minWidth: "auto",
                          width:"84px",
                        }}
                      >
                        {row.sentiment === "Positive" ? (
                          <SentimentSatisfiedOutlinedIcon
                            sx={{ color: "#23A565" }}
                          />
                        ) : row.sentiment === "Negative" ? (
                          <SentimentDissatisfiedOutlinedIcon
                            sx={{ color: "#DD2025" }}
                          />
                        ) : row.sentiment === "Neutral" ? (
                          <SentimentNeutralOutlinedIcon
                            sx={{ color: "#EED680" }}
                          />
                        ) : null
                      }
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          maxWidth: "240px",
                          minWidth:"140px",
                          width:"auto",
                        }}
                      >
                        {row?.summary}
                        {expandedRows[row.id] ? row?.summary : getShortText(row?.summary)}
                         {row?.summary?.length > 100 && (
                          <Box
                              component="span"
                              sx={{ color: "#ffffff", cursor: "pointer", ml: 1, textDecorationLine:"underline" }}
                              onClick={() => toggleExpandedSummary(row)}
                              >
                              {"Show More"}</Box>
                         )} 
                      </TableCell>
                      {/* <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          maxWidth: "240px",
                          minWidth:"140px",
                          width:"auto",
                          
                        }}
                      >
                        {expandedRows[row.id] ? row?.custom_analysis : getShortText(row?.custom_analysis)}
                         {row?.custom_analysis.length > 80 && (
                          <Box
                              component="span"
                              sx={{ color: "#ffffff", cursor: "pointer", ml: 1, textDecorationLine:"underline" }}
                              onClick={() => toggleExpanded(row)}
                              >
                              {"Show More"}</Box>
                         )}                                        
                      </TableCell> */}
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        <Box>
                          <Button onClick={(event) => { HandleActionMoreOptionClick(event, row ) }}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              borderRadius: "50%",
                              alignItems: "center",
                              maxWidth: "36px",
                              minWidth: "36px",
                              height: "36px",
                              bgcolor: "#1F233E",
                              padding: "8px",
                            }}
                          >
                            <MoreVertOutlinedIcon
                              sx={{
                                color: "#CAC4D0",
                                width: "20px",
                                height: "20px",
                                bgcolor: "#1F233E",
                              }}
                            />
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }

        </Box>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseForCloseModalDownload}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      //  sx={{ marginTop:"12px", borderRadius:"10px !important"}}
        PaperProps={{
    sx: {
      mt: 1.5, // equivalent to marginTop: "12px"
      borderRadius: "8px",
      bgcolor:"#282D51"
    },
  }}
      >
        <Box  sx={{maxWidth:"474px", width:"100%", bgcolor:"#282D51", color:"#FFFFFF", padding:"16px", borderRadius:"8px" }}>
        <Typography sx={{ p: 2, }}>Download data</Typography>
         <Box sx={{ display: "flex", flexDirection: "row", gap: "12px", marginBottom: "24px", flexWrap:"wrap", border:""}}>

           <Tooltip
                                          componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "#E6E0E9",
                                                    color: "#17182C",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    padding: "4px 8px 4px 8px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                },
                                            },
                                        }}
                                           title="Today">
                                            <Box
                                              onClick={(e) => handleOptionSelectedForCSVDOwnload("today")}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                borderRadius: "8px",
                                                border:
                                                  selectedOptionForCSVDownload === "today"
                                                    ? "1px solid rgba(255, 255, 255, 0.30)"
                                                    : "1px solid rgba(255, 255, 255, 0.10)",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                bgcolor:  selectedOptionForCSVDownload == "today" ? "#373E6D" : "transparent",
                                                color:  selectedOptionForCSVDownload === "today" ? "#FFFFFF" : "#CAC4D0",
                                                "&:hover": {
                                                  bgcolor:  selectedOptionForCSVDownload !== "today" && "#282D51",
                                                  color:  selectedOptionForCSVDownload !== "today" ? "#CAC4D0" : "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>Today</Typography>
                                            </Box>
                                          </Tooltip>

                                       <Tooltip
                                          componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "#E6E0E9",
                                                    color: "#17182C",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    padding: "4px 8px 4px 8px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                },
                                            },
                                        }}
                                           title="This week">
                                            <Box
                                              onClick={() => handleOptionSelectedForCSVDOwnload("this_week")}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                borderRadius: "8px",
                                                border:
                                                  selectedOptionForCSVDownload === "this_week"
                                                    ? "1px solid rgba(255, 255, 255, 0.30)"
                                                    : "1px solid rgba(255, 255, 255, 0.10)",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                bgcolor:  selectedOptionForCSVDownload == "this_week" ? "#373E6D" : "transparent",
                                                color:  selectedOptionForCSVDownload === "this_week" ? "#FFFFFF" : "#CAC4D0",
                                                "&:hover": {
                                                  bgcolor:  selectedOptionForCSVDownload !== "this_week" && "#282D51",
                                                  color:  selectedOptionForCSVDownload !== "this_week" ? "#CAC4D0" : "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>This week</Typography>
                                            </Box>
                                          </Tooltip>

                                            <Tooltip
                                          componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "#E6E0E9",
                                                    color: "#17182C",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    padding: "4px 8px 4px 8px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                },
                                            },
                                        }}
                                           title="This month">
                                            <Box
                                              onClick={() => handleOptionSelectedForCSVDOwnload("this_month")}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                borderRadius: "8px",
                                                border:
                                                  selectedOptionForCSVDownload === "this_month"
                                                    ? "1px solid rgba(255, 255, 255, 0.30)"
                                                    : "1px solid rgba(255, 255, 255, 0.10)",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                bgcolor:  selectedOptionForCSVDownload == "this_month" ? "#373E6D" : "transparent",
                                                color:  selectedOptionForCSVDownload === "this_month" ? "#FFFFFF" : "#CAC4D0",
                                                "&:hover": {
                                                  bgcolor:  selectedOptionForCSVDownload !== "this_month" && "#282D51",
                                                  color:  selectedOptionForCSVDownload !== "this_month" ? "#CAC4D0" : "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>This month</Typography>
                                            </Box>
                                          </Tooltip>

                                           {/* <Tooltip
                                          componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "#E6E0E9",
                                                    color: "#17182C",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    padding: "4px 8px 4px 8px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                },
                                            },
                                        }}
                                           title="Select month">
                                            <Box
                                              onClick={() => handleOptionSelectedForCSVDOwnload("select_month")}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                borderRadius: "8px",
                                                border:
                                                  selectedOptionForCSVDownload === "select_month"
                                                    ? "1px solid rgba(255, 255, 255, 0.30)"
                                                    : "1px solid rgba(255, 255, 255, 0.10)",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                bgcolor:  selectedOptionForCSVDownload == "select_month" ? "#373E6D" : "transparent",
                                                color:  selectedOptionForCSVDownload === "select_month" ? "#FFFFFF" : "#CAC4D0",
                                                "&:hover": {
                                                  bgcolor:  selectedOptionForCSVDownload !== "select_month" && "#282D51",
                                                  color:  selectedOptionForCSVDownload !== "select_month" ? "#CAC4D0" : "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>Select month <ArrowDropDownIcon/></Typography>
                                            </Box>
                                          </Tooltip> */}

                                          <Tooltip
                                          componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "#E6E0E9",
                                                    color: "#17182C",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    padding: "4px 8px 4px 8px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                },
                                            },
                                        }}
                                           title="All time">
                                            <Box
                                              onClick={() => handleOptionSelectedForCSVDOwnload("all_time")}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                borderRadius: "8px",
                                                border:
                                                  selectedOptionForCSVDownload === "all_time"
                                                    ? "1px solid rgba(255, 255, 255, 0.30)"
                                                    : "1px solid rgba(255, 255, 255, 0.10)",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                bgcolor:  selectedOptionForCSVDownload == "all_time" ? "#373E6D" : "transparent",
                                                color:  selectedOptionForCSVDownload === "all_time" ? "#FFFFFF" : "#CAC4D0",
                                                "&:hover": {
                                                  bgcolor:  selectedOptionForCSVDownload !== "all_time" && "#282D51",
                                                  color:  selectedOptionForCSVDownload !== "all_time" ? "#CAC4D0" : "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>All time</Typography>
                                            </Box>
                                          </Tooltip>
                              
                                          <Tooltip 
                                          componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "#E6E0E9",
                                                    color: "#17182C",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    padding: "4px 8px 4px 8px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                },
                                            },
                                        }}
                                          title="Custom date range">
                                            <Box
                                              onClick={() => handleOptionSelectedForCSVDOwnload("custom")}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                borderRadius: "8px",
                                                border:
                                                   selectedOptionForCSVDownload === "custom"
                                                    ? "1px solid rgba(255, 255, 255, 0.30)"
                                                    : "1px solid rgba(255, 255, 255, 0.10)",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                bgcolor: selectedOptionForCSVDownload == "custom" ? "#373E6D" : "transparent",
                                                color: selectedOptionForCSVDownload === "custom" ? "#FFFFFF" : "#CAC4D0",
                                                "&:hover": {
                                                  bgcolor: selectedOptionForCSVDownload !== "custom" && "#282D51",
                                                  color: selectedOptionForCSVDownload !== "custom" ? "#CAC4D0" : "#FFFFFF",
                                                },
                                              }}
                                            >
                                              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>Custom date range</Typography>
                                            </Box>
                                          </Tooltip>
          </Box>
              {
                renderCalendra()
              }
        </Box>
      </Popover>
       <div className="d-flex justify-content-center mt-3">
                                      <ThemeProvider theme={theme}>
                                        <Pagination
                                          count={totalPages} // Total number of pages
                                          page={currentPage} // Current page
                                          siblingCount={1} // Show one previous and one upcoming page
                                          boundaryCount={1} // Show first and last page buttons
                                          onChange={handlePageChange} // Handle page change
                                          shape="rounded" // Rounded buttons
                                          size="large" // Larger buttons
                                        />
                                      </ThemeProvider>
                                    </div>
    <CommonMoreActionOptionModal showModal={showMoreOption} setShowModal={setShowMoreOption} options={moreActionOptionArray} setOpenDeleteConformationModa={null} openEditedModal={null} setActiveUserObject={setActiveUserObject} activeUserObject={activeUserObject}/>
    <ViewTranscriptModal showViewTranscriptModal={openDetailsModal} HandleViewTranscriptModalCloseClick={HandleViewTranscriptModalCloseClick} Content={activeUserObject} Title={title}/>  
    <CommonToast 
      open={openToast}
      onClose={handleToastClose}
      content={content}
      iconType={iconType}
      bgColor={"#282D51"}
      />
    </div>
  );
};

export default Details;
